<template>
  <EditorWrapper>
    <div class="p-8">
      <div class="container max-w-6xl mx-auto">
        <h1 class="text-3xl font-semibold text-gray-700">
          Editing Mission Field on
          {{ domainStore.domain?.name }}
        </h1>
        <BaseEditor
          override-key="office.mission"
          override-type="office_mission"
        />
      </div>
    </div>
  </EditorWrapper>
</template>
<script setup>
import BaseEditor from "@/components/editor/BaseEditor.vue";
import EditorWrapper from "@/components/editor/EditorWrapper.vue";
import useDomainStore from "@/stores/domain";

const domainStore = useDomainStore();
</script>
